<template>
  <div class="cleaning-robot-page">
    <div class="layout-banner">
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/banner33.png"
        class="pc-banner"
        alt="福宝[智洁]系列ASR102光伏清洗机器人"
      />
      <img
        class="mobile-banner"
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/banner33.png"
        alt="福宝[智洁]系列ASR102光伏清洗机器人"
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          福宝[智洁]系列ASR102光伏清洗机器人
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          AI 无人值守，全天候自主清扫
        </div>
        <div
          class="use-button wow fadeInUp"
          @click="openCodeDialog"
          data-wow-delay="0.7s"
        >
          立即咨询
        </div>
      </div>
    </div>

    <div class="block-wrap" style="background-color: #f5f7fa">
      <div class="block-title page-block-title">产品简介</div>
      <div class="cotent-box">
        <div class="content-wrap">
          <div class="left-content">
            <div class="content-desc">
              福宝[智洁] ASR102
              全自动光伏清洗机器人，整机仅重30kg，辊刷可快速拆分更换，轻量化低承压，不伤光伏玻璃。搭载
              DualClean 二合一清洁模块，每小时干洗
              1200㎡，单日可清洁1~1.5MW，高效去除积尘、油污、鸟粪。双路 RTK
              厘米级自主导航，自动规划路线、断点续扫，低电量自动回仓补能；履带底盘适配
              10°以内坡面，4G
              接入光伏一点通无人值守清洗云平台，昼夜全自动作业，远程可视化管控。<br />
              配备全向超声波防坠落系统，触边即停；整机 IP65
              防尘防水，-20~60℃稳定运行，整机 6
              年设计寿命，大幅节省人工运维成本。
            </div>
            <div class="content-product-img">
              <div
                class="product-img"
                v-for="(img, idx) in productImgs"
                :key="idx"
                :class="{ active: activeIndex === idx }"
                @click="activeIndex = idx"
              >
                <img :src="img" alt="" />
              </div>
            </div>
          </div>
          <div class="right-content">
            <img
              :src="productBigImgs[activeIndex]"
              alt="ASR102光伏清洗机器人"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="advantage-wrap">
      <div class="block-title page-block-title">产品亮点</div>
      <div class="advantage-content">
        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/icon_advantage_SR102.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">AI全自动作业</div>
            <div class="advantage-desc">
              RTK 精准导航，自主清扫、自动无线回充，夜间可运行
            </div>
          </div>
        </div>

        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/icon_advantage1_SR102.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">轻量护板</div>
            <div class="advantage-desc">
              机身 21kg，分体快拆，低自重不损伤光伏面板
            </div>
          </div>
        </div>

        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/icon_advantage2_SR102.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">稳定高效清洁</div>
            <div class="advantage-desc">
              1200㎡/h 清洗效率，单日覆盖 1-1.5MW，适配干洗场景
            </div>
          </div>
        </div>

        <div class="advantage-block">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/icon_advantage3_SR102.png"
            alt=""
          />
          <div class="advantage-info">
            <div class="advantage-title">多重安全保障</div>
            <div class="advantage-desc">
              云端远程监控 + 全向防坠落，户外全天候稳定作业
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask" v-if="codeDialogFlag">
      <codeCard
        @closeDialog="closeDialog"
        :codeDialogFlag="codeDialogFlag"
      ></codeCard>
    </div>
  </div>
</template>

<script>
import codeCard from "../product/components/inspection-code.vue";

export default {
  components: {
    codeCard,
  },
  data() {
    return {
      activeIndex: 0,
      productImgs: [
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_img1_SR102.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_img2_SR102.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_img3_SR102.png",
      ],
      productBigImgs: [
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_img4_SR102.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_img5_SR102.png",
        "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/product_img6_SR102.png",
      ],
      codeDialogFlag: false,
    };
  },
  methods: {
    closeDialog() {
      this.codeDialogFlag = false;
    },
    openCodeDialog() {
      this.codeDialogFlag = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.mask {
    width: 100%;
    height:100vh;
    position:fixed;
    top:0;
    left:0;
    background: rgba(0,0,0,0.7);
    display:flex;
    justify-content:center;
    z-index:15;
    align-items:center;
}
.cleaning-robot-page {
    width:100%;
      .layout-banner {
        height:100vh;
        position:relative;

        @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;
        }
        .pc-banner {
            display:block;
        }
        .mobile-banner {
            display:none;
        }
        .text-block {
            position:absolute;
            top:50%;
            left:13%;
            transform: translateY(-50%);
            z-index: 2;
            color:#fff;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:625px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
            .use-button {
                width:9rem;
                height:2.875rem;
                font-size:1.125rem;
                letter-spacing:1px;
                cursor:pointer;
                background: #2372E9;
                line-height:2.875rem;
                text-align:center;
                margin-top:6.18rem;
                border-radius:30px;
            }
        }
    }
        .block-wrap {
        width:100%;
        position:relative;
        padding:80px 0 58px;
        background:#F5F7FA;
        .block-title {
            position:relative;
            text-align:center;
            letter-spacing:2px;
            font-weight:bold;
        }
    }
    .cotent-box{
        max-width:var(--main-width);
        width:84%;
        margin:3.6875rem auto 0;
    .content-wrap {
        width:100%;
        margin:0 auto;
        padding-bottom:2rem;
        text-align:center;
        display:flex;
        justify-content:space-between;
        align-items:center;

        .left-content {
            flex:1;
            margin-right:3.125rem;
            .content-desc {
                color:#666666;
                font-size:1rem;
                margin-bottom:4rem;
                text-align:left;
                line-height:1.8rem;
            }
            .content-product-img {
                display:flex;
                justify-content:space-between;
                .product-img {
                     transition: transform 0.3s cubic-bezier(.4,2,.6,1);
                     cursor: pointer;
                     width: 10rem;
                     border: 2px solid transparent;
                    img {
                        width:100%;
                        height:100%;
                     }
                }
                .product-img.active {
                        transform: scale(1.05);
                        border:2px solid #2372E9;
                     }

            }
        }
        .right-content {
            flex:1
            img {
                width:100%;
            }
        }
    }
    }
    .advantage-wrap {
        width:100%;
        padding:80px 0 7.75rem;
        background:#fff;
        .advantage-content {
            max-width:var(--main-width);
            width:84%;
            margin:3.6875rem auto 0;
            display: flex;
            flex-wrap: wrap;
            .advantage-block {
                display:flex;
                align-items:center;
                width: calc(50% - 30px);
                margin: 0.9375rem;
                background: linear-gradient( 180deg, #F3FCFF 0%, #F5F9FF 100%);
                border-radius: 8px;
                justify-content: space-between;
                font-size: 18px;
                box-sizing: border-box;
                padding:43px 70px 43px 45px;
                img {
                    margin-right:2.5rem;
                    width:5rem;
                }
                .advantage-info {
                    flex 1;
                    .advantage-title {
                        font-weight: bold;
                        font-size: 1.5rem;
                        color: #333333;
                        margin-bottom:0.8125rem;
                        }
                        .advantage-desc {
                            font-size: 0.875rem;
                            color: #666666;
                        }
                    }

            }
        }
    }
}

@media only screen and (max-width: 768px) {
    .cleaning-robot-page {
    .layout-banner {
        height:380px;
        margin-top:108px;
        .pc-banner {
            display:none;
        }
        .mobile-banner {
            display:block;
        }
      .text-block {
                  margin-top:0 !important;
                  width:85%;
                .title {
                   font-size:24px;
                    margin-bottom:10px;
                }
                .desc {
                     width:100%;
                    font-size:14px;
                    line-height:20px;
                }
                .use-button {
                    display:none;
                }
            }
    }
     .block-wrap{
       padding:40px 0 30px;

    .cotent-box {
       padding: 15px 15px 0;
        margin: 0px;
        width: auto;
        .content-wrap {
            flex-direction:column;
            .left-content{
                margin-right:0;
                margin-bottom:2rem;
                width:100%;
                   .content-product-img {
                    .product-img {
                        width:100px;
                        }
               }
            }
            .right-content {
               img {
                    width:100%;
                }
            }
        }
    }
   }
    .advantage-wrap {
        padding:30px 0 52px;
        .advantage-content {
             width:calc(100% - 30px);
             margin:20px auto 40px;
            .advantage-block {
                 width:calc(50% - 15px)!important;
                flex-direction:column;
                padding:16px 14px 19px 18px;
                margin:7.5px;
                img {
                    margin-right:0;
                    margin-bottom:12px;
                }
            }
        }
    }
    }
}
</style>
